// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  display: flex;
  align-items: center;
}
:host .user-like {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-end;
}
:host .user-like .like-button {
  display: flex;
  width: 46px;
  padding: 8px;
  border: 0;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  align-self: stretch;
  border-radius: 5px;
  background: #FFF3F9;
}
:host .user-like .like-button app-heart-solid-icon,
:host .user-like .like-button app-heart-empty-icon {
  cursor: pointer;
}
:host .user-like.show-animation app-heart-solid-icon {
  animation: heart 0.2s;
}

@keyframes heart {
  0% {
    transform: scale(1);
  }
  75% {
    transform: scale(1.2);
  }
  100% {
    transform: scale(1);
  }
}`, "",{"version":3,"sources":["webpack://./src/app/content/layout/components/product/product-like/product-like.component.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,mBAAA;AACF;AACE;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,qBAAA;AACJ;AACI;EACE,aAAA;EACA,WAAA;EACA,YAAA;EACA,SAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;EACA,mBAAA;EACA,kBAAA;EACA,mBAAA;AACN;AACM;;EAEE,eAAA;AACR;AAIM;EACE,qBAAA;AAFR;;AAQA;EACE;IACE,mBAAA;EALF;EAOA;IACE,qBAAA;EALF;EAOA;IACE,mBAAA;EALF;AACF","sourcesContent":[":host {\n  display: flex;\n  align-items: center;\n\n  .user-like {\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: flex-end;\n\n    .like-button {\n      display: flex;\n      width: 46px;\n      padding: 8px;\n      border: 0;\n      flex-direction: column;\n      justify-content: center;\n      align-items: center;\n      align-self: stretch;\n      border-radius: 5px;\n      background: #FFF3F9;\n\n      app-heart-solid-icon,\n      app-heart-empty-icon {\n        cursor: pointer;\n      }\n    }\n\n    &.show-animation {\n      app-heart-solid-icon {\n        animation: heart 0.2s;\n      }\n    }\n  }\n}\n\n@keyframes heart {\n  0% {\n    transform: scale(1);\n  }\n  75% {\n    transform: scale(1.2);\n  }\n  100% {\n    transform: scale(1);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
